import React from 'react';

import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type WorkflowLearningPointsProps = {
  items: string[];
};

const WorkflowLearningPoints: React.FC<WorkflowLearningPointsProps> = ({ items }) => {
  return (
    <Box
      sx={{
        borderLeft: 1,
        borderColor: 'primary.main',
        borderRadius: 2,
        p: 2.5,
        bgcolor: (theme) =>
          theme.palette.mode === 'dark' ? 'rgba(25, 118, 210, 0.06)' : 'rgba(25, 118, 210, 0.03)',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
        <AutoStoriesOutlinedIcon sx={{ fontSize: 20, color: 'primary.main' }} />
        <Typography variant="body2" fontWeight={700} color="primary.main">
          この記事で学べること
        </Typography>
      </Stack>
      <Stack spacing={0.75} sx={{ pl: 0.5 }}>
        {items.map((item, idx) => (
          <Stack key={idx} direction="row" alignItems="flex-start" spacing={1}>
            <CheckCircleOutlineIcon
              sx={{ fontSize: 16, color: 'primary.main', mt: 0.25, flexShrink: 0, opacity: 0.7 }}
            />
            <Typography variant="body2" color="text.primary" sx={{ lineHeight: 1.7 }}>
              {item}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};

export default WorkflowLearningPoints;
